import { forwardRef } from "react";
import cn from "classnames";

const defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  subtitle1: "p",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  caption: "p",
  inherit: "p",
};

const defaultVariantClass = {
  h1: "text-3xl text-[#333333] font-poppins font-bold",
  h2: "text-2xl text-[#444444] font-poppins font-semibold",
  h3: "text-lg text-[#555555] font-poppins font-semibold",
  h4: "text-base text-[#666666] font-poppins font-medium",
  subtitle1: "text-[0.905rem] text-[#666666] font-poppins font-medium",
  subtitle2: "text-[0.915rem] text-[#666666] font-poppins font-regular",
  body1: "text-base text-[#333333] font-poppins font-regular",
  body2: "text-sm text-[#333333] font-poppins font-regular",
  caption: "text-xs text-[#777777] font-poppins font-medium",
};

const Typography = forwardRef((props, ref) => {
  const {
    align = "inherit",
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = "body1",
    variantMapping = defaultVariantMapping,
    ...prop
  } = props;

  const Component =
    component ||
    (paragraph
      ? "p"
      : variantMapping[variant] || defaultVariantMapping[variant]) ||
    "span";

  return (
    <Component
      {...prop}
      className={cn(
        "",
        defaultVariantClass[variant],
        { "mb-3": gutterBottom, "whitespace-nowrap": noWrap,  },
        className
      )}
    />
  );
});

export default Typography;
